import { takeLatest, call } from 'redux-saga/effects'
import * as fromActions from '../../actions/externalCourses.action'
import downloadExternalCourse from 'api/administration/externalCourses/Download'
import { ExternalCourseModelAPI } from 'models/externalCourse.model'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'
import { ActionWithPayload } from 'helpers/redux-actions.helper'

async function handleDownload(id) {
  return downloadExternalCourse(id)
}

const pattern = fromActions.EXTERNAL_COURSE_DOWNLOAD

export type DownloadExternalCourseAction = ActionWithPayload<
  typeof pattern,
  { id: ExternalCourseModelAPI['id'] }
>

function* DownloadExternalCourseEffectSaga(
  actions: DownloadExternalCourseAction
) {
  try {
    const { id } = actions.payload
    yield call(handleDownload, id)
    SuccessToast(I18n.t('administration.toastMessages.downSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.downloadError'))
    console.error(error)
  }
}

export function* downloadExternalCourseWatcherSaga() {
  yield takeLatest(
    fromActions.EXTERNAL_COURSE_DOWNLOAD,
    DownloadExternalCourseEffectSaga
  )
}
